import { IS_BROWSER } from '$fresh/runtime.ts'
import { useSignal } from '@preact/signals'
import type { HTMLWidget, ImageWidget } from 'apps/admin/widgets.ts'
import clsx from '$store/sdk/clsx.ts'
import { lazy, Suspense } from 'preact/compat'
interface ImageMenu {
	src?: ImageWidget
	alt?: string
	height?: number
	width?: number
}

export interface NavItemProps {
	label: string
	href: string
	children?: Array<{
		label?: string
		href?: string
		seeMore?: string
		children?: Array<{
			label: string
			href: string
		}>
	}>
	image?: ImageMenu[]
	textBelowImage?: HTMLWidget
}

interface Props {
	navItems: NavItemProps[]
}

const NavItem = lazy(() => import('./NavItem.tsx'))

function Navbar({ navItems }: Props) {
	const hover = useSignal(false)
	const hoveredItem = useSignal<number | null>(null)

	return (
		<div class='flex h-[37px] container  duration-200'>
			<nav class='w-full container-center justify-center items-center'>
				<ul
					class={clsx(
						'flex justify-center h-full relative',
						'group-data-[micro-header="true"]/header:after:!hidden',
						'group-data-[micro-header="true"]/header:before:!hidden',
					)}
				>
					{navItems.map((navItem, i) => (
						<li
							onMouseEnter={() => (hoveredItem.value = i)}
							onMouseLeave={() => (hoveredItem.value = null)}
							class={clsx(
								!!navItem?.children?.length && '_hide-borders',
								'group flex items-center font-tt-norms group-data-[micro-header="false"]/header:first:font-bold group-data-[micro-header="false"]/header:last:font-bold',
							)}
						>
							<a
								href={navItem.href}
								onMouseEnter={() => (hover.value = true)}
								class="px-3 xl:px-6 group-first:px-8 xl:group-first:px-8 group-last:px-8 xl:group-last:px-8 h-full flex items-center text-sm font-medium group-data-[micro-header='true']/header:text-white group-data-[micro-header='true']/header:group-last:font-bold border-t-2 border-transparent transition-colors group-data-[micro-header='true']/header:xl:px-4 hover:text-black whitespace-nowrap"
							>
								{navItem.label}
								{navItem.children && navItem.children.length > 0 && (
									<svg
										class='ml-2 transition-transform duration-200 ease-in-out group-hover:rotate-180'
										width='10'
										height='7'
										viewBox='0 0 10 7'
										fill='none'
										xmlns='http://www.w3.org/2000/svg'
									>
										<path
											d='M4.46836 6.50937L0.218359 2.25937C-0.0753906 1.96563 -0.0753906 1.49062 0.218359 1.2L0.924609 0.49375C1.21836 0.2 1.69336 0.2 1.98398 0.49375L4.99648 3.50625L8.00898 0.49375C8.30273 0.2 8.77773 0.2 9.06836 0.49375L9.77461 1.2C10.0684 1.49375 10.0684 1.96875 9.77461 2.25937L5.52461 6.50937C5.23711 6.80312 4.76211 6.80312 4.46836 6.50937Z'
											fill='currentColor'
										/>
									</svg>
								)}
							</a>
							{hover.value &&
								IS_BROWSER &&
								navItem.children &&
								navItem.children.length > 0 && (
								<Suspense fallback={<></>}>
									<NavItem
										{...navItem}
										seeMore={navItem.href}
										textBelowImage={navItem.textBelowImage}
									/>
								</Suspense>
							)}
						</li>
					))}
				</ul>
			</nav>
		</div>
	)
}

export default Navbar
